// Firebase Analytics initialization + lightweight helpers.
// Analytics is disabled in SSR/unsupported environments (falls back to no-ops).

import { initializeApp } from 'firebase/app';
import { getAnalytics, isSupported, logEvent as fbLogEvent, setUserId as fbSetUserId } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: 'AIzaSyBfZ0CA4N5chMQOyAK3f30EhspvdUnMLuM',
  authDomain: 'today-wellness-e4bb3.firebaseapp.com',
  projectId: 'today-wellness-e4bb3',
  storageBucket: 'today-wellness-e4bb3.firebasestorage.app',
  messagingSenderId: '639071262335',
  appId: '1:639071262335:web:0d527859a19d652b93114a',
  measurementId: 'G-M2Y2FK7JV9',
};

let analyticsInstance = null;
let initPromise = null;

export const firebaseApp = initializeApp(firebaseConfig);

function initAnalytics() {
  if (analyticsInstance) return Promise.resolve(analyticsInstance);
  if (initPromise) return initPromise;
  initPromise = isSupported()
    .then((ok) => {
      if (ok) {
        analyticsInstance = getAnalytics(firebaseApp);
      }
      return analyticsInstance;
    })
    .catch(() => null);
  return initPromise;
}

// Kick off initialization as soon as the module loads
initAnalytics();

/** Log a custom analytics event. Safe no-op if analytics isn't supported. */
export function trackEvent(eventName, params = {}) {
  initAnalytics().then((a) => {
    if (a) {
      try { fbLogEvent(a, eventName, params); } catch {}
    }
  });
}

/** Convenience: page_view event with screen_name and path. */
export function trackPageView(pathname, title, screenName) {
  const params = {
    page_path: pathname,
    page_title: title || (typeof document !== 'undefined' ? document.title : '') || pathname,
    page_location: typeof window !== 'undefined' ? window.location.href : '',
  };
  if (screenName) {
    params.screen_name = screenName;
    params.screen_class = screenName;
  }
  trackEvent('page_view', params);
  // Also update GA's global config so subsequent automatic events use the correct title
  initAnalytics().then((a) => {
    if (a && screenName) {
      try { fbLogEvent(a, 'screen_view', { screen_name: screenName, screen_class: screenName }); } catch {}
    }
  });
}

/** Attach a user id (hashed / device id) for funnel analysis. */
export function setAnalyticsUserId(userId) {
  initAnalytics().then((a) => {
    if (a && userId) {
      try { fbSetUserId(a, String(userId)); } catch {}
    }
  });
}
